module.exports = __webpack_public_path__ + "images/dingtalk/icon-feedback-1-1bd0f0cd242529b5b69632c615a4ab08.png";